import {
    Button,
    TextField,
    MuiThemeProvider,
    createMuiTheme
} from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import { deleteDevelopmentStatus, getDevelopmentStatusById, postDevelopmentStatus, updateDevelopmentStatus } from '../../../../api/developmentStatus'
import { alertError, alertSuccess } from '../../../../utils/logger'
import Editor from '../../../components/editor/Editor'
import MultilanguageTabBlock from '../../../components/MultilanguageTabBlock'
import { useSkeleton } from '../../../hooks/useSkeleton'
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";

// Create theme for delete button (red)
const theme = createMuiTheme({
    palette: {
        secondary: {
            main: "#F64E60",
        },
    },
});

function getEmptyText() {
    return {
        title: {
            'es': "",
            'en': ""
        },
        description: {
            'es': "",
            'en': ""
        }
    }
}

export default function EditDevelopmentStatusPage() {
    const developmentStatusId = useParams().id;
    const history = useHistory();
    const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton();

    const [developmentStatus, setDevelopmentStatus] = useState(getEmptyText())
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);


    useEffect(() => {
        if (!developmentStatusId) {
            disableLoadingData();
            return
        }

        getDevelopmentStatusById(developmentStatusId).then(res => {
            setDevelopmentStatus(res.data)
            disableLoadingData()
        }).catch(error => {
            alertError({ error: error, customMessage: 'Could not get development status.' })
            history.push('/developmentStatus')
        })
    }, [developmentStatusId, disableLoadingData, history])

    function saveDevelopmentStatus() {
        if (!developmentStatusId) {
            postDevelopmentStatus(developmentStatus)
                .then((res) => {
                    alertSuccess({
                        title: "Saved!",
                        customMessage: "Development status created successfully.",
                    });
                    history.push("/developmentStatus");
                })
                .catch((error) => {
                    alertError({
                        error: error,
                        customMessage: "Could not save the development status.",
                    });
                });
        } else {
            updateDevelopmentStatus(developmentStatusId, developmentStatus).then(res => {
                alertSuccess({ title: 'Saved!', customMessage: 'Changes successfully saved.' })
                history.push('/developmentStatus')
            }).catch(error => {
                alertError({ error: error, customMessage: 'Could not save changes.' })
            })
        }
    }

    const handleChange = (element, lang) => (event) => {
        if (lang) {
            if (event.target.value === ' ')
                return
            if (!developmentStatus[element])
                developmentStatus[element] = {}
            let newText = developmentStatus[element]
            newText[lang] = event.target.value
            setDevelopmentStatus({ ...developmentStatus, [element]: newText })
        } else
            setDevelopmentStatus({ ...developmentStatus, [element]: event.target.value })
    }

    const handleChangeEditor = (element, lang, value) => {
        if (lang) {
            if (value === ' ')
                return
            if (!developmentStatus[element])
                developmentStatus[element] = {}
            let newText = developmentStatus[element]
            newText[lang] = value
            setDevelopmentStatus({ ...developmentStatus, [element]: newText })
        } else
            setDevelopmentStatus({ ...developmentStatus, [element]: value })
    }


    const renderMultilanguageTabContent = lang => {
        return (
            <>
                <TextField
                    label="Title"
                    value={(developmentStatus.title && developmentStatus.title[lang]) || ''}
                    onChange={handleChange('title', lang)}
                    margin="normal"
                    variant="outlined"
                    required
                />
                <Editor
                    body={(developmentStatus.description && developmentStatus.description[lang]) || ''}
                    setBody={new_body => handleChangeEditor('description', lang, new_body)}
                    className='max-height'
                    lang={lang}
                    placeholder={'Enter text content here...'}
                />
            </>
        )
    }

    if (isLoadingData)
        return <ContentSkeleton />

    return (
        <>
            <Card>
                <CardHeader title='Edit development status'>
                </CardHeader>
                <CardBody>
                    <MultilanguageTabBlock
                        multilanguageTabContent={renderMultilanguageTabContent}
                    />
                </CardBody>
            </Card>
            <Button
                onClick={() => history.push('/developmentStatus')}
                variant="outlined"
                style={{ marginRight: '20px' }}>
                Back
            </Button>
            <Button
                onClick={() => saveDevelopmentStatus()}
                variant="outlined"
                color="primary"
                style={{ marginRight: '20px' }}>
                Save development status
            </Button>

            {developmentStatusId && (
                <>
                    <MuiThemeProvider theme={theme}>
                        <Button
                            onClick={() => setOpenConfirmDialog(true)}
                            variant="outlined"
                            color="secondary"
                            style={{ marginRight: "20px" }}
                        >
                            Delete development status
                        </Button>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                marginLeft: "auto",
                            }}
                        ></div>
                    </MuiThemeProvider>

                    <ConfirmDialog
                        title={"Are you sure you want to delete this development status?"}
                        open={openConfirmDialog}
                        setOpen={setOpenConfirmDialog}
                        onConfirm={() => {
                            deleteDevelopmentStatus(developmentStatusId)
                                .then((res) => {
                                    alertSuccess({
                                        title: "Deleted!",
                                        customMessage: "Development status deleted successfully.",
                                    });
                                    history.push("/developmentStatus");
                                })
                                .catch((error) => {
                                    alertError({
                                        error: error,
                                        customMessage: "Could not delete the development status.",
                                    });
                                });
                        }}
                    />
                </>
            )}
        </>
    );
}